import { useState, useEffect } from 'react';
import { Callbacks } from '../constants/configuration';
import { GetLinkToPlatonFormProps, paymentsApi } from '../services/apiServices/user/payments';
import { useCustomSnackbar } from './useCustomEnqueueSnackbar';
import { getErrorMessage } from '../utils';

export const usePlaton = () => {
  const [platonData, setPlatonData] = useState<GetLinkToPlatonFormProps>({
    amount: 0,
    description: '',
    url: Callbacks.PaymentSuccess,
    error_url: Callbacks.PaymentError,
    source: process.env.REACT_APP_HOME || '',
    order: '',
  });
  const { customEnqueueSnackbar } = useCustomSnackbar();

  const [trigger, { data, error, isLoading, isError }] = paymentsApi.useLazyGetLinkToPlatonFormQuery();

  useEffect(() => {
    if (error) {
      const message = getErrorMessage(error);
      customEnqueueSnackbar(message, 'error');
    }
  }, [error]);

  return {
    platonData,
    setPlatonData,
    reFetchPlatonAPI: trigger,
    getLinkToPlatonFormAPI: data,
    isPlatonLoading: isLoading,
    isPlatonError: isError,
  };
};
